import React from 'react';
import { Button, Dropdown, Option } from './DropdownButton.style';

const DropdownButton = ({text, options}) => {
    const [ onHover, setOnHover ] = React.useState(false);
    return (
        <Button onMouseEnter={() => setOnHover(true)} onMouseLeave={() => setOnHover(false)}>
            {text}<i className={`fas fa-chevron-${onHover ? 'up' : 'down'}`} />
            <Dropdown isVisible={onHover}>
                {options && options.map((option, i) =>
                    <Option key={i} href={option.url}>{option.text}<i/></Option>
                )}
            </Dropdown>
        </Button>
    );
}
 
export default DropdownButton;